import PinCheckbox from '@activities/easyCard/common/PinCheckbox';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useIsBioDevice from '@hooks/easyCard/useIsBioDevice';
import { useTranslation } from 'react-i18next';

import PinDots from './PinDots';

interface Props {
    pin: string;
    /** 없으면 기본 입력 안내 문구를 보여준다 */
    guide?: string;
    /** true면 안내 문구를 오류 색상으로 보여준다 */
    isError?: boolean;
    useBio?: boolean;
    /** 없으면 생체 인증 체크를 보여주지 않는다 */
    onUseBioChange?: (useBio: boolean) => void;
    /** true면 생체인증 기기로 등록되지 않았어도 생체 인증 체크를 보여준다 */
    alwaysShowUseBio?: boolean;
}

/** PIN 입력 화면의 안내 문구·입력 자릿수·생체 인증 체크 */
function PinContents({
    pin, guide, isError, useBio, onUseBioChange, alwaysShowUseBio,
}: Props) {
    const { t } = useTranslation('easyCard');
    const isBioDevice = useIsBioDevice();
    return (
        <Container justify='space-between' align='center' fullWidth >
            <Contents spacing={6} fullWidth align='center'>
                <Text size='title' color={isError ? colors.textError : undefined}>
                    {guide ?? t('pin.inputGuide')}
                </Text>
                <PinDots length={pin.length}/>
            </Contents>
            {(onUseBioChange && (isBioDevice || alwaysShowUseBio)) && (
                <PinCheckbox
                    isChecked={!!useBio}
                    onClick={() => onUseBioChange(!useBio)}/>
            )}
        </Container>
    );
}

const Contents = styled(Column)`
    //padding-top: var(--spacing-10);
    padding-top: 40px;
`;

const Container = styled(Column)`
    flex: 1;
    //padding-bottom: var(--spacing-8);
    padding-bottom: 32px;
`;

export default PinContents;
